import { render, staticRenderFns } from "./SettingsStageTieMatchAllowed.vue?vue&type=template&id=e3305052&"
import script from "./SettingsStageTieMatchAllowed.vue?vue&type=script&lang=js&"
export * from "./SettingsStageTieMatchAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports